import { HttpErrorResponse } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, inject, DestroyRef ,
  ChangeDetectionStrategy,
} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { DSTSharedService } from 'projects/gtw-elements/src/app/DST/shared/dst-shared.service';
import { TaxTypePipe } from 'projects/gtw-elements/src/app/DST/shared/pipes/taxtype.pipe';
import { forkJoin, Observable, tap } from 'rxjs';
import {StmtAttrData, StmtData} from '../../../../../../shared/models/dst-form-state.model';
import {CreateDisclosureSharedService, DropDownType, EntityNameChange} from '../../../create-disclosure-shared.service';

@Component({
    selector: 'dst-view-template-sec332-id190',
    templateUrl: './view-template-sec332-id190.component.html',
    styleUrls: ['../../template-shared.scss', './view-template-sec332-id190.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ViewTemplateSec332Id190Component implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  form190!: UntypedFormGroup;
  stmtData!: StmtData;
  attMap: any;
  loaded: boolean = false;
  pickListVal: string = '';
  propertyValBasisOptions: any = [];
  currencyOptions: any = [];
  descTotalAvl: boolean = false;
  selBasisTxt: string = '';
  corpTypeTxt: string = '';
  startLoader: boolean = false;
  disableActions: boolean = false;
  s3Uploading: boolean = false;
  primaryEntityName: string = '';
  secondaryEntityName: string = '';
  primaryCorpTypeTxt: string = '';
  secondaryCorpTypeTxt: string = '';

  constructor(private formBuilder: UntypedFormBuilder,
              private dstSharedService: DSTSharedService,
              private sharedService: CreateDisclosureSharedService,
              private taxTypePipe: TaxTypePipe,
              private cdr: ChangeDetectorRef) {
    this.disableActions = this.sharedService.disableActions;
    this.sharedService.disableActions = false;
  }

  ngOnInit(): void {
    this.startLoader = true;
    this.form190 = this.formBuilder.group({
      header: this.formBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      })
    });

    //load required Filters
    //PropertyValBasis Options
    this.sharedService.getBasisDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        //console.log(data);
        data.forEach(element => {
          this.propertyValBasisOptions.push({
            value: element.id,
            label: element.text
          });
        });
      }, () => {

      }, () => {

      });

    //load currencies
    this.sharedService.getCurrencyDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.currencyOptions.push({
            value: element.id,
            label: element.text
          });
        });
      }, () => {

      }, () => {

      });

    //load Stmt data
    this.sharedService.getLoadStatementData(190).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: StmtData) => {
        this.stmtData = response;
        this.primaryEntityName = this.stmtData.primaryentity || '';
        this.secondaryEntityName = this.stmtData.secondaryentity || '';

        //load all attributes into new object for showing on UI as key value pair
        this.attMap = {};

        this.stmtData.children?.forEach((stmt: StmtAttrData) => {
          if (!this.attMap[stmt.attributeName]) {
            this.attMap[stmt.attributeName] = [];
          }

          if (stmt.attributeValue !== undefined) {

            this.attMap[stmt.attributeName]?.push(stmt.attributeValue);
          } else {
            //console.log('stmt.attributeName---'+ stmt.attributeName);
            this.attMap[stmt.attributeName]?.push(undefined);
          }


        });
        console.log('After loop Attr data 332-CTB: ' + JSON.stringify(this.attMap));

        /*//check totals are available
        if (this.attMap['Desc'].length >= 1) { this.descTotalAvl = true }
        if (this.attMap['Desc1'].length >= 1) { this.basisAmt1Total = true }*/

        if (this.attMap['LiquidationStatus'] !== undefined && this.attMap['LiquidationStatus'][0] != '') {
          //Select pickList Val
          this.sharedService.getLiquidationStateDropdown(1).pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data: DropDownType[]) => {
              data.forEach(element => {
                if (element.id == this.attMap['LiquidationStatus'][0]) {
                  this.pickListVal = element.text;
                }

              });
            }, () => {

            }, () => {

            });
        }

        //check totals are available
        if (this.attMap['Desc'].length >= 1) {
          this.descTotalAvl = true;
        }

        //Set all the values that needed from the service calls
        this.propertyValBasisOptions.forEach((val: { value: number; label: string }) => {

          if ((this.attMap['Basis'] !== undefined) && (val.value == this.attMap['Basis'][0])) {
            this.selBasisTxt = val.label;
          }

        });

        //corpTypeTxt
        //this.updateEntitiesInfo(this.stmtData?.primaryleid!, 1);
        //this.updateEntitiesInfo(this.stmtData?.secondaryleid!, 2);
        forkJoin([

          this.updateEntitiesInfo(this.stmtData?.primaryleid!, 1),
          this.updateEntitiesInfo(this.stmtData?.secondaryleid!, 2)

        ]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(([response1, response2]) => {
          this.cdr.detectChanges();

          requestAnimationFrame(() => {
            setTimeout(() => {
              const html = document.querySelector('#temp332');
              const htmlContent = html!.outerHTML;
              this.sharedService.getFormStateByFormId(190)!.doPDFSync && this.htmlToPdfConversion(htmlContent.toString());
            }, 0);
          });
        }, (error: HttpErrorResponse) => {

          console.log(error);
          this.dstSharedService.showAlert('error', error.message);

        }).add(() => {
          this.loaded = true;
          this.startLoader = false;
        });

      }, () => {

      }, () => {

      }).add(() => {
        this.loaded = true;
        this.startLoader = false;
      });

  }

  htmlToPdfConversion(htmlContent: string, isS3upload: boolean = false): void {
    this.sharedService.saveHTMLToPDFStatement(htmlContent!, 'Section332-CheckTheBox.pdf', this.stmtData.statementid).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: any) => {
        isS3upload && (this.dstSharedService.showAlert('success', 'The Form got successfully uploaded to S3!'));
        isS3upload && (this.s3Uploading =  false);
      }, (eMsg: string) => {
        console.log(eMsg);
        isS3upload && (this.dstSharedService.showAlert('error', eMsg));
      });
  }

  s3Upload(): void {
    this.s3Uploading = true;
    const html = document.querySelector('#temp332');
    const htmlContent = html!.outerHTML;
    this.htmlToPdfConversion(htmlContent, true);
  }

  //getCurrencyText
  getSelCurrency(valFor?: number): string {
    let retVal = '';
    this.currencyOptions.forEach((val: { value: number; label: string }) => {
      if (val.value == this.attMap['Currency'][0] && valFor == 0) {
        retVal = val.label;
      } else if (val.value == this.attMap['Currency'][1] && valFor == 1) {

        retVal = val.label;
      } else if (val.value == this.attMap['Currency'][2] && valFor == 2) {

        retVal = val.label;
      }

    });

    return retVal;
  }

  totalAmt(amtFor?: String): number {
    let totalAmt = 0;
    const addAmt = (amt: any) => {
      const value = Number(String(amt ?? '').replace(/,/g, ''));
      if (Number.isFinite(value)) {
        totalAmt += value;
      }
    };
    if (amtFor == 'BasisAmt') {
      (this.attMap['BasisAmt'] || []).forEach(addAmt);
    } else if (amtFor == 'FMVAmt') {
      (this.attMap['FMVAmt'] || []).forEach(addAmt);
    } else if (amtFor == 'BasisAmt1') {
      (this.attMap['BasisAmt1'] || []).forEach(addAmt);
    }
    return totalAmt;
  }

  updateEntitiesInfo(leid: string, entityType: number): Observable<EntityNameChange[]> {
    this.startLoader = true;
    return this.sharedService.checkForEntityNameChange(this.stmtData?.statementid.toString(),
      leid,
      this.sharedService.getTransDateStr(this.attMap['EffectiveDate'][0], 1),
      this.sharedService.getTaxYearStr(this.stmtData)
    ).pipe(
      tap({
        next: (response => {
          if (response && response[0]) {
            //override entity type
            const corpType = this.taxTypePipe.transform(response[0], response[0].TAXTYPECODE, true);
            if (response && response[0]) {
				//override entity name & entity type
				const corpType = this.taxTypePipe.transform(response[0], response[0].TAXTYPECODE, true);
				if (entityType === 1) { //primary entity
				  (response[0].LE_NAME) && (this.primaryEntityName = response[0].LE_NAME);
				  this.primaryCorpTypeTxt = corpType;
				} else if (entityType === 2) { //secondary entity
				  (response[0].LE_NAME) && (this.secondaryEntityName = response[0].LE_NAME);
				  this.secondaryCorpTypeTxt = corpType;
				}
			  }
          }
        })
      })
    )
  }

  save(): void {
    this.sharedService.setFormData(this.stmtData);
    this.sharedService.setSavedStatementId(this.stmtData.statementid.toString());
    this.sharedService.switchTemplateMode(false);
  }

  cancel(): void {
    this.onCancel.emit();
  }

}
